import React from 'react'
import leaf from "src/assets/images/icon-leaf-black.png";
import leafadd from "src/assets/images/rohs_10_compliant.png";
import save from "src/assets/images/save.png";
import noncancel from "src/assets/images/icon-non-cancel-black.png";
import tariff from "src/assets/images/shape.png";
import specialPricing from "src/assets/images/special-pricing.png";
import reel from "src/assets/images/tap-round.png";
import ban from "src/assets/images/ban.png";
import designhub from "src/assets/images/designhub-ledgend-icon.png";
import cut from "src/assets/images/cut.png";
import new_product from "src/assets/images/highlighter.png";
import online from "src/assets/images/online.png";
import rohs_exempt from "src/assets/images/rohs_10_exempt.png";
import top_seller from "src/assets/images/star.png";
import eol from "src/assets/images/eol.png";
import cross_round from "src/assets/images/cross-round.png";
import hazardous from "src/assets/images/hazardous-icon.svg";
import { Tooltip } from 'src/component/Global/Tooltip';
import Product from "@system/config/product";
import System from 'src/helper/system';

const ProductLegends = (props) => {
    const { single_product, onlyIcon, onlyIconTitle } = props;
    const { translation: t } = System;

    const renderLegendIcon = (iconPath, message, showIcon) => {
        return (
            showIcon ?
                (
                    <>
                        <span className="list-text-icon"><img className="img-fluid me-1" alt="Legend Information Icon" src={iconPath} /></span>
                    </>
                ) :
                (
                    <>
                        <Tooltip
                            position={'bottom left'}
                            opener={() => (
                                <span className="list-text-icon"><img
                                    className="img-fluid me-1" alt="Legend Information Icon"
                                    src={iconPath} /></span>
                            )}
                            content={() => (message)}
                        />
                    </>
                )
        )
    };

    const getROHSCompliantValueByCode = (ROHSCompliantCode) => {
        if (ROHSCompliantCode) {
            if (single_product.ROHSCompliantCodeValue === undefined) {
                return Product.product__ROHSCompliantCode(ROHSCompliantCode);
            }
            return single_product.ROHSCompliantCodeValue;
        }
        return ROHSCompliantCode;
    }
    return (
        <>
            {single_product &&
                <>
                    {/*RoHS Complaint */}
                    {single_product.ROHSCompliantCode && (single_product.ROHSCompliantCode.toUpperCase() === 'Y' ||
                        single_product.ROHSCompliantCode.toUpperCase() === 'C') &&
                        <li>
                            {(onlyIcon) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'Y' ? leaf : leafadd), getROHSCompliantValueByCode(single_product.ROHSCompliantCode), false)}
                                </>
                            }
                            {(onlyIconTitle) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'Y' ? leaf : leafadd), '', true)}
                                    <span>{single_product.ROHSCompliantCodeValue}</span>
                                </>
                            }
                        </li>
                    }
                    {/* RoHS Non-Complaint */}
                    {single_product.ROHSCompliantCode && single_product.ROHSCompliantCode.toUpperCase() === 'N' &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(ban, getROHSCompliantValueByCode(single_product.ROHSCompliantCode), false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(ban, '', true)}
                                    <span>{single_product.ROHSCompliantCodeValue}</span>
                                </>
                            }
                        </li>
                    }
                    {/* RoHS Exempt */}
                    {single_product.ROHSCompliantCode && (single_product.ROHSCompliantCode.toUpperCase() === 'E' ||
                        single_product.ROHSCompliantCode.toUpperCase() === 'X') &&
                        <li>
                            {(onlyIcon) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'E' ? rohs_exempt : cross_round), getROHSCompliantValueByCode(single_product.ROHSCompliantCode), false)}
                                </>
                            }
                            {(onlyIconTitle) &&
                                <>
                                    {renderLegendIcon((single_product.ROHSCompliantCode.toUpperCase() === 'E' ? rohs_exempt : cross_round), '', true)}
                                    <span>{single_product.ROHSCompliantCodeValue}</span>
                                </>
                            }
                        </li>
                    }

                    {/* NCNR Flag */}
                    {single_product.NCNRFlag &&
                        <li>
                            {(onlyIcon) &&
                                <>
                                    {renderLegendIcon(noncancel, `${t('nonCancelable')}, ${t('nonReturnable')}`, false)}
                                </>
                            }
                            {(onlyIconTitle) &&
                                <>
                                    {renderLegendIcon(noncancel, '', true)}
                                    <span>{t('nonCancelable')},{t('nonReturnable')}</span>
                                </>
                            }
                        </li>
                    }
                    {/* Cut Tape */}
                    {single_product.PackagingTypeCode && (single_product.PackagingTypeCode.toUpperCase() === 'BKN' ||
                        single_product.PackagingTypeCode.toUpperCase() === 'CST') &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(cut,'Cut Tape', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(cut, '', true)}
                                    <span>Cut Tape</span>
                                </>
                            }
                        </li>
                    }
                    {/* Web Only */}
                    {single_product.WebOnlyFlag &&
                        <li className="obsolete-popup">
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(online,'On-line', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(online, '', true)}
                                    <span>On-line</span>
                                </>
                            }
                        </li>
                    }
                    {/* New Product */}
                    {single_product.NPIFlag &&
                        <li className="obsolete-popup">
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(new_product, t('newProduct'), false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(new_product, '', true)}
                                    <span>{t('newProduct')}</span>
                                </>
                            }
                        </li>
                    }
                    {/* Obsolete Flag */}
                    {single_product.ObsoleteFlag &&
                        <li className='obsolete-popup'>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(save, 'Obsolete', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(save, '', true)}
                                    <span>Obsolete</span>
                                </>
                            }
                        </li>
                    }
                    {/* Top Seller Flag */}
                    {single_product.TopSellerFlag &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(top_seller, 'Top Seller', false)}
                                </>

                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(top_seller, '', true)}
                                    <span>Top Seller</span>
                                </>
                            }
                        </li>
                    }
                    {/* End Of Life Flag */}
                    {single_product.EndOfLifeFlag &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(eol, 'End Of Life', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(eol, '', true)}
                                    <span>End Of Life</span>
                                </>
                            }
                        </li>
                    }

                    {/* End Of Life Flag */}
                    {single_product?.IsDesignsAvailable &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(designhub, 'Design Available', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(designhub, '', true)}
                                    <span>Design Available</span>
                                </>
                            }
                        </li>
                    }

                    {single_product?.HazardousFlag &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(hazardous, t('hazardousItemsDesc'), false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(hazardous, '', true)}
                                    <span>Hazardous</span>
                                </>
                            }
                        </li>
                    }
                    {/* Tariff Charges */}
                    {single_product?.IsTariffEligible &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(tariff, t('tariffCharges'), false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(tariff, '', true)}
                                    <span>{t('tariffCharges')}</span>
                                </>
                            }
                        </li>
                    }
                    {/* Reel */}
                    {single_product?.custom_reel_flag &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(reel, 'Reel', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(reel, '', true)}
                                    <span>Reel</span>
                                </>
                            }
                        </li>
                    }
                    {/* Special Pricing */}
                    {single_product?.specialPriceFlag &&
                        <li>
                            {onlyIcon &&
                                <>
                                    {renderLegendIcon(specialPricing, 'Special Pricing', false)}
                                </>
                            }
                            {onlyIconTitle &&
                                <>
                                    {renderLegendIcon(specialPricing, '', true)}
                                    <span>Special Pricing</span>
                                </>
                            }
                        </li>
                    }

                </>
            }
        </>
    )
}

export default ProductLegends